/**
 * Utility: Safely unwrap a Supabase single-relation join result.
 *
 * PostgREST returns joined relations as either an object or an array
 * depending on the FK cardinality and query shape. This helper normalises
 * both forms so callers don't need repeated `Array.isArray` checks.
 *
 * @example
 * const dept = unwrapJoin<{ name: string }>(row.departments);
 * // dept is { name: string } | null
 */
export function unwrapJoin<T>(raw: unknown): T | null {
  if (raw == null) return null;
  if (Array.isArray(raw)) return (raw[0] as T) ?? null;
  if (typeof raw === "object") return raw as T;
  return null;
}
